import { RootState } from '../../../../utils/type';

export const selectVendorCommissions = (state: RootState) => state.vendorCommission.data;
export const selectVendorCommissionLoading = (state: RootState) => state.vendorCommission.loading;
export const selectVendorCommissionError = (state: RootState) => state.vendorCommission.error;
export const selectVendorCommissionUpdating = (state: RootState) => state.vendorCommission.updating;
export const selectVendorCommissionUpdateError = (state: RootState) => state.vendorCommission.updateError;
export const selectVendorCommissionUpdateSuccess = (state: RootState) => state.vendorCommission.updateSuccess;
